import { CoursePage } from '@/pages/Admin/Course'
import { LevelingPage } from '@/pages/Admin/Leveling'
import { SuccessLevelingPage } from '@/pages/Admin/Leveling/Success'
import { ProgressCheckPage } from '@/pages/Admin/ProgressCheck'
import { ProgressTypeformPage } from '@/pages/Admin/ProgressTypeform'

export const coursesRoutes: Array<RoutesType> = [
	{
		name: 'Curso - Visão Geral',
		path: '/curso',
		layout: 'course',
		roles: ['student', 'single_course', 'white_label'],
		element: CoursePage,
		isPrivate: true,
	},
	{
		name: 'Curso - Biblioteca',
		path: '/curso/biblioteca',
		layout: 'course',
		roles: ['student', 'single_course', 'white_label'],
		element: CoursePage,
		isPrivate: true,
	},
	{
		name: 'Curso - Teste de Nivelamento',
		path: '/curso/nivelamento',
		layout: 'library',
		roles: ['student', 'single_course', 'white_label'],
		element: LevelingPage,
		isPrivate: true,
	},
	{
		name: 'Curso - Progress Check',
		path: '/curso/progress-check',
		layout: 'progress',
		roles: ['student', 'single_course', 'white_label'],
		element: ProgressCheckPage,
		isPrivate: true,
	},
	{
		name: 'Curso - Progress Check - Nivelamento',
		path: '/curso/progress-check/nivelamento',
		layout: 'library',
		roles: ['student', 'single_course', 'white_label'],
		element: ProgressTypeformPage,
		isPrivate: true,
	},
	{
		name: 'Curso - Sucesso Teste de Nivelamento',
		path: '/curso/sucesso-nivelamento',
		layout: 'success',
		roles: ['student', 'single_course', 'white_label'],
		element: SuccessLevelingPage,
		isPrivate: true,
	},
]
